import { useEffect, useState } from 'react';

/**
 * Ticks a `now` `Date` every `intervalMs` (default 30s) — shared by WorldScreen's forage-ready
 * chip, ShopScreen's restock clock, and ForageScreen's cooldown clock (task-18-brief.md: "restock
 * clock ticking via a 30 s interval"). 30s (not, say, 1s) is deliberate — `formatEta`
 * (web/src/lib/formatEta.ts, task-17) is already coarse (minutes at finest grain, C3 "no
 * urgency"), so anything finer than the label's own resolution would just burn renders without
 * ever changing what's on screen. `now` lives in component state (not a ref) so passing it to
 * `formatEta` re-derives the label on every tick; the interval is cleared on unmount, same as
 * every other effect-owned timer/listener in this codebase (see `useOnline`'s own
 * addEventListener/removeEventListener pair).
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
